module.exports = __webpack_public_path__ + "media/images/font/Gustavo-Bold-3e01b2e34e9c9edfde4c30c0f736d0de.eot";